<template>
  <span
    :class="{ basket: true, 'not-empty': products_quantity != null }"
    @click="handleSidebar"
    :data-quantity="products_quantity"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20.48"
      height="18"
      viewBox="0 0 20.48 18"
    >
      <g id="basketB" transform="translate(0 -31)">
        <path
          id="Path_198"
          data-name="Path 198"
          d="M325,305.789a.6.6,0,0,0,.69-.493l.6-3.6a.6.6,0,0,0-1.184-.2l-.6,3.6A.6.6,0,0,0,325,305.789Z"
          transform="translate(-311.518 -259.196)"
          fill="#02317f"
        />
        <path
          id="Path_199"
          data-name="Path 199"
          d="M144.106,305.3a.6.6,0,0,0,1.184-.2l-.6-3.6a.6.6,0,1,0-1.184.2Z"
          transform="translate(-137.758 -259.198)"
          fill="#02317f"
        />
        <path
          id="Path_200"
          data-name="Path 200"
          d="M19.88,37H17.769l-4.62-5.775a.6.6,0,0,0-.937.75L16.232,37H4.248l4.02-5.025a.6.6,0,0,0-.937-.75L2.712,37H.6a.6.6,0,0,0-.6.6V40a.6.6,0,0,0,.6.6h.747l2.276,7.965A.6.6,0,0,0,4.2,49H16.28a.6.6,0,0,0,.577-.435L19.133,40.6h.747a.6.6,0,0,0,.6-.6V37.6a.6.6,0,0,0-.6-.6ZM15.828,47.8H4.653L2.6,40.6H17.885Zm3.453-8.4H1.2V38.2H19.28Z"
          fill="#02317f"
        />
        <path
          id="Path_201"
          data-name="Path 201"
          d="M241.6,305.8a.6.6,0,0,0,.6-.6v-3.6a.6.6,0,0,0-1.2,0v3.6A.6.6,0,0,0,241.6,305.8Z"
          transform="translate(-231.36 -259.2)"
          fill="#02317f"
        />
      </g>
    </svg>
  </span>
</template>

<script>
export default {
  name: "Basket",
  data() {
    return {
      state_class: "",
    };
  },
  props: {
    products_quantity: {
      type: Number,
      required: false,
    },
  },
  methods: {
    handleSidebar() {
      this.$emit("handle_sidebar");
    },
  },
  created() {
    const vm = this;
    //vm.showVideo(vm.content.page)
  },
  mounted() {
    const vm = this;
  },
  updated() {},
};
</script>